import '../MyPackagesScreen/AffiliateComponent.css'

import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { Button, Modal, Spinner } from 'react-bootstrap'
import { useSelector } from 'react-redux'

import copiedIcon from '../../../imgs/check-mark.png'
import copyIcon from '../../../imgs/copy-icon.png'
import { getRef, sendEmailAffReq } from '../../../services/affiliates'
import { getCouponByRefUserId } from '../../../services/coupon'

export default function AffiliateComponent() {
  const { loggedUser } = useSelector(state => state.user)
  const [refUserData, setRefUserData] = useState({})
  const [isCopied, setIsCopied] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [coupons, setCoupons] = useState([])
  const formAboutRef = useRef(null)
  const formLinksRef = useRef(null)
  const [show, setShow] = useState(false)
  const [textForAlert, settextForAlert] = useState('')

  const getRefUser = useCallback(async () => {
    try {
      const refUser = await getRef(loggedUser.UserAttributes['custom:refNum'])
      if (refUser.refUserId) {
        setRefUserData(refUser)
        const coupons = await getUserCoupons(refUser.refUserId)
        setCoupons(coupons)
      }
    } catch (error) {
      alert(`Failed! \n ${error.response.data?.msg}`)
    } finally {
      setIsLoading(false)
    }
  }, [loggedUser.UserAttributes])

  useEffect(() => {
    getRefUser()
  }, [getRefUser])

  const getUserCoupons = async refUserId => {
    try {
      const res = await getCouponByRefUserId(refUserId)
      // console.log("getUserCoupons - res", res)
      return res
    } catch (error) {
      // console.log(error)
      throw error
    }
  }

  const copyLink = async () => {
    const text = document.querySelector('.ref-link').innerText
    navigator.clipboard.writeText(text)
    setIsCopied(true)
  }

  const submitHandler = async () => {
    if (!formAboutRef.current.value) return
    const user = loggedUser.UserAttributes
    const data = `name: ${user.name} ${user.family_name}. phone: ${user.phone_number}. email: ${user.email}.
    ספרי לנו על עצמך: ${formAboutRef.current.value}. לינקים: ${formLinksRef.current.value}`

    try {
      await sendEmailAffReq(data)
      settextForAlert('המייל נשלח בהצלחה! תודה. נחזור אלייך בהקדם')
      setShow(true)
    } catch (error) {
      console.log('submitHandler - error:', error)
      settextForAlert('שגיאה. אנא נסי שנית.')
      setShow(true)
    }
  }

  const formatDate = dateString => {
    const date = new Date(dateString)
    return date.toLocaleDateString('he-IL')
  }

  const getPaymentsByType = type => {
    const filteredPayments = refUserData.paymentsHistory.filter(payment => payment.type === type)
    return filteredPayments
  }

  const calculateSum = paymentsArray => {
    return paymentsArray.reduce((sum, payment) => Number(sum) + Number(payment.payment), 0)
  }

  const remainingCouponsPayments = useMemo(() => {
    const totalEarningsCoupons = coupons.reduce((sum, coupon) => {
      return sum + Math.round(coupon.revenue * coupon.totalFinalPayments)
    }, 0)
    const paidCoupons =
      refUserData.paymentsHistory?.filter(p => p.type === 'Coupon').reduce((sum, p) => sum + parseFloat(p.payment), 0) || 0
    return totalEarningsCoupons - paidCoupons
  }, [coupons, refUserData.paymentsHistory])

  function PaymentHistoryTable({ title, type, tableClass }) {
    const payments = getPaymentsByType(type)
    const sum = calculateSum(payments)

    return (
      <div className={`aff-payment-table-container ${tableClass}`}>
        <div className='aff-payment-table-header'>
          <h5>{title}</h5>
          <div className='aff-payment-table-sum'>
            סה"כ: <span>{sum}₪</span>
          </div>
        </div>
        <div className='aff-custom-table'>
          <div className='aff-table-header'>
            <div className='aff-header-cell'>תאריך</div>
            <div className='aff-header-cell'>סכום</div>
          </div>
          <div className='aff-table-body'>
            {payments.length > 0 ? (
              payments.map((payment, idx) => (
                <div className='aff-table-row' key={idx}>
                  <div className='aff-table-cell'>{formatDate(payment.date)}</div>
                  <div className='aff-table-cell'>{payment.payment}₪</div>
                </div>
              ))
            ) : (
              <div className='aff-table-row aff-empty-table'>
                <div className='aff-empty-message'>אין תשלומים להצגה</div>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }

  function PaymentHistoryTables() {
    return (
      <div className='aff-payment-history-section'>
        <h4 className='aff-payment-history-title'>היסטוריית תשלומים</h4>
        <div className='aff-payment-tables-container'>
          <PaymentHistoryTable title='תשלומי לינק הרשמה' type='Shipments' tableClass='aff-payment-table-shipments' />
          <PaymentHistoryTable title='תשלומי קופונים' type='Coupon' tableClass='aff-payment-table-coupons' />
          <PaymentHistoryTable title='תשלומי גיפט קארד' type='Giftcard' tableClass='aff-payment-table-giftcards' />
        </div>
      </div>
    )
  }

  function NoRefCmp() {
    return (
      <div className='no-ref'>
        מעוניינת להיות שותפה להצלחה 🚀 שלנו?
        <br />
        מלאי את הפרטים ונחזור אליך בימים הקרובים 😇
        <div className='aff-form'>
          <div style={{ textAlign: 'right' }}>ספרי לנו על עצמך:</div>
          <textarea ref={formAboutRef} rows='4' style={{ width: '100%' }}></textarea>
          <br />
          <br />
          <div style={{ textAlign: 'right' }}>לינקים לעמודים שלך ברשתות החברתיות:</div>
          <textarea ref={formLinksRef} rows='4' style={{ width: '100%' }}></textarea>
          <Button onClick={submitHandler}>שלחי</Button>
        </div>
      </div>
    )
  }

  function CouponsCmp() {
    return (
      <div className='ref-coupons-cont'>
        <h5>:הקופונים שלך</h5>
        <div className='coupons-stats'>
          {coupons.map((coupon, idx) => {
            return (
              <div className='coupon-card' key={idx}>
                <h5>{coupon.code}</h5>
                <span className='stat'>
                  <span>שימושים בקופון:</span> {coupon.timesUsed}
                </span>
                <span className='stat'>
                  <span>הרווח שלך עד כה:</span> {Math.round(coupon.revenue * coupon.totalFinalPayments)}₪
                </span>
              </div>
            )
          })}
        </div>
        <br />

        <div className='coupons-stats'>
          <div className='coupon-card'>
            <span className='stat'>
              <span>שולם:</span>{' '}
              {refUserData.paymentsHistory?.filter(p => p.type === 'Coupon').reduce((sum, p) => sum + parseFloat(p.payment), 0) || 0}₪
            </span>
            <span className='stat'>
              <span>נותר לתשלום:</span> {remainingCouponsPayments}₪
            </span>
          </div>
        </div>
      </div>
    )
  }

  function RefUserCmp() {
    return (
      <div className='ref-refuser-cont'>
        <div className='has-ref-head'>
          <h5>:הלינק שלך</h5>
          <div className='ref-link'>shiptanbul.com/?ref={loggedUser.UserAttributes['custom:refNum']}</div>
          <div className='ref-copy-cont'>
            <div
              className='copy-btn-ref'
              onClick={() => {
                copyLink()
              }}
            >
              <div>העתק</div>
              <img src={isCopied ? copiedIcon : copyIcon} width='20px' />
            </div>
          </div>
        </div>
        <div className='ref-stats'>
          <div className='ref-stats-row'>
            <span className='stat'>
              <span>משתמשים שנרשמו:</span> {refUserData.registeredUsers}
            </span>
            <span className='stat'>
              <span>חבילות שנרכשו:</span> {refUserData.boughtPackages}
            </span>
          </div>

          <span className='stat'>
            <span>הרווח שלך עד כה:</span> {Math.round(refUserData.packagesShipmentIncome * refUserData.rev)}₪
          </span>
          <span className='stat'>
            <span>שולם:</span>{' '}
            {refUserData.paymentsHistory?.filter(p => p.type === 'Shipments').reduce((sum, p) => sum + parseFloat(p.payment), 0) || 0}₪
          </span>
          <span className='stat'>
            <span>נותר לתשלום:</span>{' '}
            {Math.round(refUserData.packagesShipmentIncome * refUserData.rev) -
              (refUserData.paymentsHistory?.filter(p => p.type === 'Shipments').reduce((sum, p) => sum + parseFloat(p.payment), 0) || 0)}
            ₪
          </span>
        </div>
      </div>
    )
  }

  const getCmp = () => {
    if (refUserData?.refUserId) {
      if (refUserData.isOnHold) return <CouponsCmp />
      return (
        <>
          <RefUserCmp />
          <CouponsCmp />
          {refUserData.paymentsHistory && refUserData.paymentsHistory.length > 0 && <PaymentHistoryTables />}
        </>
      )
    } else return <NoRefCmp />
  }

  return (
    <section>
      <h4 className='ref-title'>שיווק שותפים</h4>
      {isLoading ? (
        <div style={{ textAlign: 'center' }}>
          <Spinner animation='border' variant='primary' />
        </div>
      ) : (
        getCmp()
      )}

      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header style={{ textAlign: 'right' }}>
          <div style={{ width: '100%' }}>
            <Modal.Title style={{ direction: 'rtl' }}>שים לב!</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>{textForAlert}</Modal.Body>
        <Modal.Footer style={{ direction: 'rtl' }}>
          <Button variant='danger' onClick={() => setShow(false)}>
            סגור
          </Button>
        </Modal.Footer>
      </Modal>
    </section>
  )
}
